import { Leads } from "./pages/leads/page";
import { Auth } from "./pages/login/auth";
import { TLPCloudLoginPage } from "./pages/login/login";
import { Maps } from "./pages/maps";
export function Dev() {
	return <Auth />;
	// return <Leads />;
	//return <Maps entityType="" entityId="" />;
}
